(function() {
  function initOnePack(packsEl) {
    const formWrap = packsEl.nextElementSibling && packsEl.nextElementSibling.matches('.product-pack-form-wrap')
      ? packsEl.nextElementSibling
      : document.querySelector('.product-pack-form-wrap');

    const selOne = packsEl.querySelector('select[name="options-pack-one"]');
    const selTwo = packsEl.querySelector('select[name="options-pack-two"]');
    if (!selOne || !selTwo) return;

    const bundleVariantIdInput = formWrap ? formWrap.querySelector('.bundle-variant-id') : null;
    const submitBtn = formWrap ? formWrap.querySelector('.product-form__submit') : null;
    const totalAmount = formWrap ? formWrap.querySelector('.total-amount-pack') : null;

    let variants = [];
    try {
      variants = JSON.parse(packsEl.getAttribute('data-all-variant-bundle') || '[]');
    } catch {}

    const titleOne = packsEl.querySelector('.product-one .producto-pack-title')?.textContent?.trim() || '';
    const titleTwo = packsEl.querySelector('.product-two .producto-complementary-title')?.textContent?.trim() || '';
    const isHoodie = t => /hoodie/i.test(t);
    const isPant = t => /pant/i.test(t);

    let mapOne = null, mapTwo = null;
    if (isHoodie(titleOne)) mapOne = 'option1';
    if (isPant(titleOne)) mapOne = 'option2';
    if (isHoodie(titleTwo)) mapTwo = 'option1';
    if (isPant(titleTwo)) mapTwo = 'option2';

    const findDirect = (v1, v2) => variants.find(v => v.available && v.option1 === v1 && v.option2 === v2);
    const findSwapped = (v1, v2) => variants.find(v => v.available && v.option1 === v2 && v.option2 === v1);

    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      const euros = (cents / 100).toFixed(2).replace('.', ',');
      return `€${euros}`;
    }

    function detectOrientation(v1, v2) {
      if (mapOne && mapTwo) {
        const direct = mapOne === 'option1' && mapTwo === 'option2';
        const swapped = mapOne === 'option2' && mapTwo === 'option1';
        if (direct) return 'direct';
        if (swapped) return 'swapped';
      }
      const hasDirect = !!findDirect(v1, v2);
      const hasSwapped = !!findSwapped(v1, v2);
      if (hasDirect && !hasSwapped) return 'direct';
      if (!hasDirect && hasSwapped) return 'swapped';
      if (isHoodie(titleOne) && isPant(titleTwo)) return 'direct';
      if (isPant(titleOne) && isHoodie(titleTwo)) return 'swapped';
      return 'direct';
    }

    function applyMatch(match) {
      if (!bundleVariantIdInput) return;
      bundleVariantIdInput.value = match ? match.id : '';
      if (submitBtn) {
        submitBtn.disabled = !match;
        const span = submitBtn.querySelector('span');
        if (span) span.textContent = match ? 'Add to cart' : 'Not available';
      }
      if (match && totalAmount && match.price != null) {
        totalAmount.textContent = formatMoney(match.price);
      }
    }

    let orientation = 'unknown';

    function updateSelection() {
      const v1 = selOne.value;
      const v2 = selTwo.value;
      if (orientation === 'unknown') orientation = detectOrientation(v1, v2);
      let match = orientation === 'direct' ? findDirect(v1, v2) : findSwapped(v1, v2);
      if (!match) {
        const expected = `${v1} / ${v2}`;
        match = variants.find(v => v.available && (v.public_title === expected || v.title === expected));
      }
      if (!match) {
        const alt = orientation === 'direct' ? findSwapped(v1, v2) : findDirect(v1, v2);
        if (alt) orientation = orientation === 'direct' ? 'swapped' : 'direct', applyMatch(alt);
        else applyMatch(null);
      } else applyMatch(match);
    }

    updateSelection();
    selOne.addEventListener('change', updateSelection);
    selTwo.addEventListener('change', updateSelection);
  }

  function initAllPacks(root) {
    (root || document).querySelectorAll('.packs[data-all-variant-bundle]').forEach(initOnePack);
  }

  document.addEventListener('DOMContentLoaded', () => initAllPacks(document));
  document.addEventListener('shopify:section:load', e => initAllPacks(e.target));
})();
